export const fonts = [
  {
    "material-community": require("../../assets/fonts/MaterialCommunityIcons.ttf"),
    BrandRegular: require("../../assets/fonts/Rubik-Regular.ttf"),
    BrandMedium: require("../../assets/fonts/Rubik-Medium.ttf"),
  },
];
